import { Component } from 'react';

import { type NumberFormatValues } from '@procurifydev/react-number-format'
import { isUndefined } from 'lodash'

import { NumberFieldStyled } from './styles/NumberFieldStyled'
import { type IUIProviderValue, UIContext } from '../../core'
import {
  type ITextFieldProps as MuiTextFieldProps,
  TextField,
} from '../TextField'

// Wrapper around NumberFormat component
export class NumberFormatCustom extends Component<any> {
  static defaultProps = {}
  static contextType = UIContext
  context: IUIProviderValue

  render() {
    const {
      inputRef,
      onValueChange,
      value,
      decimalPlaces,
      thousandSeparator,
      placeholder,
      ...otherProps
    } = this.props

    const { decimalSeparator } = this.context.i18n
    const { decimalPlaces: defaultDecimalPlaces } = this.context.NumberField

    return (
      <NumberFieldStyled
        value={value}
        getInputRef={inputRef}
        onValueChange={onValueChange}
        decimalSeparator={decimalSeparator}
        thousandSeparator={
          thousandSeparator ? this.context.i18n.thousandSeparator : ''
        }
        decimalScale={
          !isUndefined(decimalPlaces) ? decimalPlaces : defaultDecimalPlaces
        }
        prefix=''
        placeholder={placeholder}
        {...otherProps}
      />
    )
  }
}

// Wrapper around Material UI TextField component
// Use NumberFormatCustom by default
export interface NumberFieldProps {
  decimalPlaces?: number
  thousandSeparator?: boolean
  onValueChange?: (values: NumberFormatValues) => void
  error?: boolean
}

export type INumberFieldProps = NumberFieldProps & MuiTextFieldProps

export const NumberField = (props: INumberFieldProps) => {
  const {
    InputProps,
    inputProps,
    onValueChange,
    value,
    decimalPlaces,
    thousandSeparator,
    ...otherProps
  } = props

  return (
    <TextField
      fullWidth={true}
      InputProps={{
        ...InputProps,
        inputComponent: NumberFormatCustom,
      }}
      inputProps={{
        decimalPlaces,
        thousandSeparator,
        // 'aria-labelledby': otherProps.name,
        ...inputProps,
        onValueChange,
        value,
      }}
      {...otherProps}
    />
  )
}
NumberField.displayName = 'NumberField'
